var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgPriceCheck = function SvgPriceCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "price_check"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 13V9C11 8.45 10.55 8 10 8H6V6H11V4H8.5V3H6.5V4H5C4.45 4 4 4.45 4 5V9C4 9.55 4.45 10 5 10H9V12H4V14H6.5V15H8.5V14H10C10.55 14 11 13.55 11 13Z",
    fill: "url(#paint0_linear_52372_17104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.59 12.52L12.93 18.17L10.1 15.34L8.69 16.76L12.93 21L20 13.93L18.59 12.52Z",
    fill: "url(#paint1_linear_52372_17104)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52372_17104",
    x1: 4,
    y1: 3,
    x2: 21.3836,
    y2: 3.65506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846071,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52372_17104",
    x1: 4,
    y1: 3,
    x2: 21.3836,
    y2: 3.65506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846071,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27B"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgPriceCheck);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/price_check.a508038016d79d5058c586f292968940.svg";